/* ─────────────────────────────────────────────
   MBS Deep Structural Support — shared JS
   Reveal, count-up, word stagger, sticky CTA.
   Loaded once per page via {{ 'lp-mbs.js' | asset_url | script_tag }}.
───────────────────────────────────────────── */

(function init() {
  'use strict';

  var root = document.querySelector('.lp-mbs-root');
  if (!root) {
    // Each lp-mbs section loads this file with a blocking script placed before
    // its own markup, so the first copy on a page runs before any .lp-mbs-root
    // exists. When that section is the only lp-mbs section (e.g. the FAQ on the
    // elasticity listicle), no later copy runs either, and its reveal content
    // stays at opacity 0. Retry once the document has been parsed.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    }
    return;
  }

  var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || inDesignMode) {
    document.body.classList.add('mbs-no-motion');
  }

  // ── Word-split for richtext headlines marked with data-mbs-word-split ──
  function splitHeadlineWords(el) {
    if (el.dataset.mbsSplit) return;
    el.dataset.mbsSplit = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (tn) {
      if (!tn.nodeValue || !tn.nodeValue.trim()) return;
      var parts = tn.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (p) {
        if (/^\s+$/.test(p)) {
          frag.appendChild(document.createTextNode(p));
        } else if (p) {
          var span = document.createElement('span');
          span.className = 'mbs-hero-word';
          span.textContent = p;
          frag.appendChild(span);
        }
      });
      tn.parentNode.replaceChild(frag, tn);
    });
  }
  document.querySelectorAll('[data-mbs-word-split]').forEach(splitHeadlineWords);

  // ── Hero word stagger ──
  var words = document.querySelectorAll('.mbs-hero-word');
  if (words.length) {
    words.forEach(function (w, i) {
      w.style.transitionDelay = (0.08 * i + 0.15) + 's';
    });
    setTimeout(function () {
      words.forEach(function (w) { w.classList.add('in'); });
    }, 120);
  }

  // ── Reveal on scroll ──
  if ('IntersectionObserver' in window && !reducedMotion && !inDesignMode) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.mbs-reveal').forEach(function (el) {
      revealObs.observe(el);
    });
  } else {
    document.querySelectorAll('.mbs-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  // ── Count-up stats ──
  var counters = document.querySelectorAll('[data-mbs-counter]');
  if (counters.length && 'IntersectionObserver' in window && !reducedMotion) {
    var counterObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.dataset.mbsDone) return;
        el.dataset.mbsDone = '1';

        var target = parseFloat(el.dataset.mbsCounter);
        var dur = 1600;
        var start = performance.now();
        function tick(t) {
          var p = Math.min(1, (t - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = (target * eased).toFixed(1);
          el.childNodes[0].nodeValue = val;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });

    counters.forEach(function (c) { counterObs.observe(c); });
  } else {
    counters.forEach(function (el) {
      var target = parseFloat(el.dataset.mbsCounter);
      if (!isNaN(target)) {
        el.childNodes[0].nodeValue = target.toFixed(1);
      }
    });
  }

  // ── Diagram / timeline animation trigger (adds .in to trigger CSS transitions) ──
  ['.lp-mbs-mech__diagram', '.lp-mbs-timeline'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (!el) return;
    if (reducedMotion || inDesignMode) { el.classList.add('in'); return; }
    if (!('IntersectionObserver' in window)) { el.classList.add('in'); return; }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });
    obs.observe(el);
  });

  // ── Sticky CTA bar — show after hero, hide in pricing ──
  var stickyCta = document.querySelector('.lp-mbs-sticky-cta');
  if (stickyCta && 'IntersectionObserver' in window) {
    var heroEl = document.querySelector('.lp-mbs-hero');
    var pricingEl = document.querySelector('.lp-mbs-pricing');

    function updateSticky() {
      if (!heroEl) return;
      var heroBottom = heroEl.getBoundingClientRect().bottom;
      var pricingTop = pricingEl ? pricingEl.getBoundingClientRect().top : Infinity;
      if (heroBottom < 0 && pricingTop > window.innerHeight) {
        stickyCta.classList.add('show');
      } else {
        stickyCta.classList.remove('show');
      }
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }
})();
